module.exports = __webpack_public_path__ + "static/crime-982add9bf619d9bc269cf2f67c4498e8.png";